import { OmsTableInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import { z } from "zod";

export const getBatchHistoryCount = {
  input: OmsTableInputSchema,
  output: z.object({ total: z.number() }),
};
